<template>
  <transition name="slide-fade">
    <div class="l-modal-mask">
      <div class="sidebar-right">
        <div class="row mb-2">
          <div class="col">
            <h1 class="modal-h1 mb-3">
              <button type="button" class="btn btn-back" @click="$emit('closeModal')" />
              New claim
            </h1>
          </div>
        </div>
        <div>
          <div class="row mb-2">
            <div class="col pr-1">
              <div class="select-wrap">
                <label>Claim type:</label>
                <simple-select
                  v-model="claim.claim_type_id"
                  :options="claimTypes"
                  placeholder="Select type"
                  @input="errors.clear('claim_type_id')"
                />
              </div>
              <error-field :errors="errors" field="claim_type_id" />
            </div>
            <div class="col pl-1 pr-1">
              <div class="select-wrap">
                <label>Claim priority:</label>
                <simple-select
                  v-model="claim.claim_priority_id"
                  :options="claimPriorities"
                  track-by="id"
                  placeholder="Medium"
                />
              </div>
              <error-field :errors="errors" field="claim_priority_id" />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col pr-1">
              <div class="select-wrap">
                <label>Claim title:</label>
                <input type="text" v-model="claim.title" class="form-control" ref="title" autocomplete="no" />
              </div>
              <error-field :errors="errors" field="title" />
            </div>
          </div>
          <div class="row mb-2">
            <div class="col">
              <div class="select-wrap h-auto">
                <label>Claim description:</label>
                <textarea v-model="claim.description" class="select-wrap-textarea form-control" rows="5"
                          ref="description"
                />
              </div>
              <error-field :errors="errors" field="description" />
            </div>
          </div>
        </div>
        <div class="row mb-2" v-if="$_can('claims.assign')">
          <div class="col pr-1">
            <div class="select-wrap">
              <label>Assign claim:</label>
              <simple-select
                placeholder="Select agent"
                v-model="claim.cluster_user_id"
                :options="claimsUsers"
                :custom-label="customLabel"
              />
            </div>
            <error-field :errors="errors" field="cluster_user_id" />
          </div>
          <div class="col pl-1 pr-1" />
        </div>
        <div class="row w-100 job-buttons position-absolute">
          <div class="col-12 py-2 border-top text-right">
            <button type="button" class="btn btn-secondary" @click="$emit('closeModal')">
              Cancel
            </button>
            <button type="button" class="btn btn-primary ld-ext-right"
                    @click="createClaim"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
            >
              Save
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import toastr from 'toastr';
import axios from 'axios';
import Errors from '../../../classes/Errors';

export default {
  name: 'CreateClaimModal',
  props: {
    job: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    errors: new Errors(),
    claim: {
      ref_id: '',
      title: '',
      description: '',
      claim_type_id: null,
      claim_priority_id: '2',
      cluster_user_id: null,
    },
    loadingButton: false,
    buttonDisabled: false,
  }),
  computed: {
    ...mapState({
      claimTypes: state => state.claims.claimTypes.data,
      claimPriorities: state => state.claims.claimPriorities.data,
      claimsUsers: state => state.claims.claimsUsers.data,
    }),
  },
  mounted() {
    this.getClaimsUsers();
    this.getClaimTypes(this.job.company_id);
    this.getClaimPriorities();
  },
  methods: {
    ...mapActions(['getClaimTypes', 'getClaimPriorities', 'getClaimsUsers', 'createNewClaim']),
    customLabel(option) {
      return (
        `${option.first_name === undefined ? '' : option.first_name}` +
        ` ${option.last_name === undefined ? '' : option.last_name}`
      );
    },
    createClaim() {
      this.claim.ref_id = this.job.ref_id;
      this.loadingButton = true;
      this.buttonDisabled = true;
      axios
        .post('/claims', { ...this.claim })
        .then(() => {
          toastr.success('Claim created successfully');
          this.$emit('update');
          this.$emit('closeModal');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/claims/Modals/CreateClaim.vue